import { type PropsWithChildren, useCallback, useMemo, useState } from 'react'

import { DiffPresenceContext } from './diffPresenceContext'

/**
 * Keeps count of the comparisons actually on show beneath it.
 *
 * A comparison popover only knows what it holds once it has drawn it: a section
 * renders nothing when its two sides read the same, and the reader can filter
 * whole sections away. So the control that chooses how comparisons are laid out
 * cannot be placed on the strength of which popover it is in, it has to wait
 * and see whether any comparison turned up.
 */
export const DiffPresenceProvider = ({ children }: PropsWithChildren) => {
  const [count, setCount] = useState(0)

  const register = useCallback(() => {
    setCount((previous) => previous + 1)

    return () => setCount((previous) => previous - 1)
  }, [])

  const presence = useMemo(
    () => ({ hasAnyDiff: count > 0, register }),
    [count, register],
  )

  return <DiffPresenceContext value={presence}>{children}</DiffPresenceContext>
}
